import { render } from "./AdminTable.vue?vue&type=template&id=e3572706&scoped=true"
import script from "./AdminTable.vue?vue&type=script&lang=js"
export * from "./AdminTable.vue?vue&type=script&lang=js"

import "./AdminTable.vue?vue&type=style&index=0&id=e3572706&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e3572706"

export default script